import React from 'react';
import { Link } from 'react-router-dom';
import {FaFacebook,FaInstagram,FaYoutube,FaTwitter} from 'react-icons/fa';
import payment from '../../assests/image/payment.png';
import '../../assests/css/footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="container pt-10 pb-8 mx-auto px-5 lg:px-0">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div>
                        <div className="logo">
                            <Link to="/">
                                <h4 className='text-2xl font-semibold text-gray-600'> <span className='text-5xl text-blue-400'>B</span>akiz</h4>
                            </Link>
                        </div>
                        <div className='mt-2'>
                            <h4 className='font-semibold mb-1'>Follow Us On Social Media</h4>
                            <div className="flex space-x-4 text-xl cursor-pointer">
                                <FaFacebook className='text-blue-500'/>
                                <FaInstagram className='text-blue-500'/>
                                <FaYoutube className='text-blue-500'/>
                                <FaTwitter className='text-blue-500'/>
                            </div>
                        </div>
                    </div>
                    <div className="categories">
                        <h3 className='text-xl font-semibold mb-3'>Categories</h3>
                        <ul>
                            <li>Diapers</li>
                            <li>Nutrition</li>
                            <li>Baby Care</li>
                            <li>Fashion</li>
                            <li>Milk</li>
                            <li>Toys</li>
                        </ul>
                    </div>
                    <div className="account">
                        <h3 className='text-xl font-semibold mb-3'>Account</h3>
                        <ul>
                            <li>My Account</li>
                            <li>My Orders</li>
                            <li>Wishlist</li>
                            <li>Returns</li>
                        </ul>
                    </div>
                    <div className="account">
                        <h3 className='text-xl font-semibold mb-3'>Information</h3>
                        <ul>
                            <li>Terms & Condition</li>
                            <li>Privacy Policy</li>
                            <li>Refund Policy</li>
                            <li>About Us</li>
                        </ul>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center py-4">
                    <div>
                        <p className='font-medium'>Copyright © 2022 Bakiz. All Rights Reserved</p>
                    </div>
                    <div>
                        <img src={payment} alt="payment bg" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;